export default __webpack_public_path__ + "static/media/emailPIcon.92223a7c.png";